export enum PasswordFlowMode {
  FORGOT = 'FORGOT',
  EXPIRED = 'EXPIRED',
  CHANGE = 'CHANGE'
}
